import WMTSCapabilities from 'ol/format/WMTSCapabilities';

/* OpenLayers imports */
import OlTileLayer from 'ol/layer/Tile';
import OlWMTSSource, { optionsFromCapabilities } from 'ol/source/WMTS';
import OlWMTSTilegrid from 'ol/tilegrid/WMTS';
import { getTopLeft as OlGetTopLeft } from 'ol/extent';
/* lodash imports */
import { toArray, map } from 'lodash';

import { NEDGLOBE_MAP_PROJECTION } from '../../../constants';
import { getRequestUrl } from './';

export const createWmtsLayer = function (layerData, highQuality) {
    // create OLSource for the layer
    let olWmtsSource;
    const style = layerData.wmtsStyle !== null ? layerData.wmtsStyle : '_null';
    const matrixIds = toArray(map(layerData.tileMatrixSet.tileMatrices, function (tilematrix) {
        return tilematrix.identifier;
    }));
    if (layerData.olLayerOptions) {
        let options = layerData.olLayerOptions;
        // use custom endpoint and set cors for high quality tiles or for secured services
        if (layerData.isSecured || highQuality) {
            options = {
                ...layerData.olLayerOptions,
                crossOrigin: 'Anonymous',
                url: layerData.customEndPoints.wmts.url,
            };
            delete options.urls;
            delete options.requestEncoding;
        }
        olWmtsSource = new OlWMTSSource(options);
    } else {

        // Set WMTS Style if available, otherwise use default
        const url = highQuality ? layerData.customEndPoints.wmts.url : getRequestUrl(layerData);
        // create source from parameters
        olWmtsSource = new OlWMTSSource({
            crossOrigin: highQuality ? 'Anonymous' : undefined,
            url: url,
            layer: layerData.layerName,
            matrixSet: layerData.tileMatrixSet.identifier,
            format: layerData.format,
            projection: NEDGLOBE_MAP_PROJECTION,
            tileGrid: new OlWMTSTilegrid({
                origin: OlGetTopLeft(NEDGLOBE_MAP_PROJECTION.getExtent()),
                resolutions: layerData.resolution.slice(0, matrixIds.length),
                matrixIds: matrixIds
            }),
            style: style
        });
    }
    // create new OLLayer
    return new OlTileLayer({
        title: layerData.title,
        id: layerData.id,
        combinedId: layerData.getCombinedOlId(),
        type: 'WMTS',
        preload: Infinity,
        opacity: 1,
        source: olWmtsSource,
    });
};

export const getWmtsOptions = async function ({ dispatch }, layerId, layerName, tileMatrixSet) {
    const result = await dispatch('useApiData', {
        name: 'WebThemeLayerGetWMTSCapabilities',
        parameters: {
            id: layerId
        }
    });
    return parseWmtsOptions(result.data, layerName, tileMatrixSet.identifier);
};

export const parseWmtsOptions = function (optionsData, layerName, tileMatrixSetIdent) {
    const parser = new WMTSCapabilities();
    let options;
    try {
        const capabilities = parser.read(optionsData);
        options = optionsFromCapabilities(capabilities, {
            layer: layerName,
            matrixSet: tileMatrixSetIdent,
        });
    } catch (error) {
        // TODO error or remove catch
        console.log(`parseWmtsOptions: ${error}`);
        // throw error;
    }
    return options;
};
